import repairConfig from '../table/configs/refrigerator_repair_tracking.json';
import {ActionCompletionDialogComponent} from '../common/action-completion-dialog/action-completion-dialog.component';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthService} from '../services/auth.service';
import {CommonService} from '../services/common.service';
import {Component, OnInit, ViewChild} from '@angular/core';
import {Details} from '../details/details';
import {MatDialog} from '@angular/material';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material';
import {RecycleCommandsService} from '../services/recycle-commands.service';
import {RefrigeratorsService} from '../services/refrigerators.service';
import {SaleCommandsService} from '../services/sale-commands.service';
import {SimpleConfirmActionDialogComponent} from '../common/simple-confirm-action-dialog/simple-confirm-action-dialog.component';
import {ToastMessagesService} from '../services/toast-messages.service';

@Component({
  templateUrl: './refrigerator-details.component.html'
})
export class RefrigeratorDetailsComponent extends Details implements OnInit {

  @ViewChild(MatSort, {static: false}) set matSort(ms: MatSort) {
    this.sort = ms;
    this.setDataSourceAttributes();
  }
  @ViewChild(MatPaginator, {static: false}) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    this.setDataSourceAttributes();
  }

  data: any;
  private paginator: MatPaginator;
  private refrigerator: any;
  private sort: MatSort;
  public basicDetailsConfig: any;
  public canShow: boolean;
  public dataSource: MatTableDataSource<any>;
  public initializePage: boolean;
  public isLoading: boolean;
  public mainDataSections: any[];
  public refrigeratorId: number;
  public repairTrackingConfig: any;
  user: any;

  public displayedColumns: string[] = ['id', 'serial_number', 'date_completed', 'sender', 'recipient', 'command_type_description'];

  constructor(private activatedRoute: ActivatedRoute,
              private authService: AuthService,
              public commonService: CommonService,
              private matDialog: MatDialog,
              private recycleCommandsService: RecycleCommandsService,
              private router: Router,
              private saleCommandsService: SaleCommandsService,
              private refrigeratorsService: RefrigeratorsService,
              private toastMessagesService: ToastMessagesService) {
    super();

    this.initializePage = false;
    this.isLoading = true;
    this.canShow = false;
    this.dataSource = new MatTableDataSource<any>([]);
  }

  public ngOnInit(): void {
    this.activatedRoute.paramMap.subscribe(async (params) => {
      this.refrigeratorId = +params.get('id');
      await this.initUser();
      await this.initializeRefrigeratorDetails(+params.get('id'));

      this.data = await this.commonService.insertObject(`refrigerator/transport_tracking`,
        {serial_number: this.refrigerator.serial_number});
      this.dataSource = new MatTableDataSource<any>(this.data);
      this.dataSource.data.forEach(row => {
       row.date_completed_for_search = this.commonService.formatDate(row.date_completed);
     });
      this.initializePage = true;
      this.isLoading = false;
    });
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  async initializeRefrigeratorDetails(id: number) {
    this.refrigerator = await this.refrigeratorsService.getRefrigerator(id);
    this.canShow = this.authService.isUserBelongsToWithdrawalRoles(this.user.role_alternate_name, this.user.sales_group_ids);
    this.basicDetailsConfig = {
      actions: [],
      infoRow: [],
      status_name: this.refrigerator.quality_name,
      status_value: this.refrigerator.quality_id,
      subtitle: [
        {
          title: 'Σειριακός Αριθμός',
          value: this.refrigerator.serial_number
        }
      ],
      title: 'Πληροφορίες Ψυγείου'
    };
    await this.initializeActions();

    this.mainDataSections = [this.refrigeratorsService.initializeRefrigerator(this.refrigerator)];
    this.repairTrackingConfig = (JSON.parse(JSON.stringify(repairConfig)));
    this.repairTrackingConfig.filter = `serial_number='${this.mainDataSections[0].values[0].value}'`;
  }

  private async initializeActions() {
    const actions = [];
    const show = this.authService.isUserBelongsTo('basicUser');
    const action1 = {
      function: () => {
        this.updateRefrigeratorCondition();
      },
      showAction: (show || this.user.role_alternate_name === 'technicalManager'),
      title: this.refrigerator.is_new === 1 ? `Ορισμός Ψυγείου ως Μεταχειρισμένο`
        : `Ορισμός Ψυγείου ως Νέο`,
      icon: 'kitchen'
    };

    const action2 = {
      function: () => {
        this.updateRefrigeratorPhase();
      },
      showAction: this.refrigerator.phase_id !== 5 && (show || this.user.role_alternate_name === 'technicalManager'),
      title:  `Ορισμός Ψυγείου ως Διαθέσιμο`,
      icon: 'done',
      tooltip: this.refrigerator.phase_id === 5 ? 'Το ψυγείο είναι διαθέσιμο' : ''

    };

    const action3 = {
      function: () => {
        this.updateRefrigeratorSalePoint();
      },
      showAction: show,
      title:  `Αφαίρεση Σημείου Πώλησης`,
      icon: 'storefront'
    };

    const action4 = {
      function: () => {
        this.reEvaluateRefrigerator();
      },
      showAction: await this.canShowReEvaluation(),
      title:  `Επαναξιολόγηση`,
      icon: 'repeat'
    };

    const action5 = {
      function: () => {
        this.recycleRefrigerator();
      },
      showAction: await this.canShowReEvaluation(),
      title:  `Ανακύκλωση`,
      icon: 'recycling'
    };

    const action6 = {
      function: () => {
        this.saleRefrigerator();
      },
      showAction: await this.canShowReEvaluation()
        && (this.refrigerator.sale_point_id === 22341 || this.refrigerator.sale_point_id === 22342),
      title:  `Πώληση`,
      icon: 'currency_exchange'
    };

    actions.push(action1);
    actions.push(action2);
    actions.push(action3);
    actions.push(action4);
    actions.push(action5);
    actions.push(action6);

    if (actions.length > 0) {
      this.basicDetailsConfig.actions = actions;
      this.basicDetailsConfig.showActions = true;
      // this.basicDetailsConfig.showActions = this.user.role_alternate_name === 'basicUser';
    } else {
      this.basicDetailsConfig.showActions = false;
    }
  }

  private async initUser() {
    this.user = await this.authService.getUser();
  }

  private async canShowReEvaluation() {
    return !!((this.refrigerator.phase_id === 5 || this.refrigerator.phase_id === 13) && this.refrigerator.evaluation_category_id === 5 && this.canShow);
  }

  public navigateToRow(row) {
    this.router.navigate([`${row.command_url}/${row.id}`]);
  }

  private updateRefrigeratorCondition() {
    const confirm = this.matDialog.open(SimpleConfirmActionDialogComponent, {
      data: {
        title: 'Ενημέρωση Κατάστασης Ψυγείου',
        message: `Είστε σίγουροι ότι
        θέλετε να θέσετε το ψυγείο ως ${this.refrigerator.is_new === 0 ? 'Νέο' : 'Μεταχειρισμένο'};`
      }
    });

    confirm.afterClosed().subscribe(async (result) => {
      if (result) {
        try {
          await this.commonService.updateObject(`refrigerator/change_status`,
            {id : this.refrigerator.id, is_new: this.refrigerator.is_new === 0 ? 1 : 0});
          this.toastMessagesService.toastMessages(`Η ενημέρωση του ψυγείου πραγματοποιήθηκε με επιτυχία`);
          location.reload();
        } catch (e) {
          this.toastMessagesService.toastErrorMessage(e.message);
        }
      }
    });
  }

  private updateRefrigeratorPhase() {
    const confirm = this.matDialog.open(SimpleConfirmActionDialogComponent, {
      data: {
        title: 'Ενημέρωση Φάσης Ψυγείου',
        message: `Είστε σίγουροι ότι
        θέλετε να θέσετε το ψυγείο ως διαθέσιμο;`
      }
    });

    confirm.afterClosed().subscribe(async (result) => {
      if (result) {
        try {
          await this.commonService.updateObject(`refrigerator/change_phase`,
            {id : this.refrigerator.id});
          this.toastMessagesService.toastMessages(`Η ενημέρωση του ψυγείου πραγματοποιήθηκε με επιτυχία`);
          location.reload();
        } catch (e) {
          this.toastMessagesService.toastErrorMessage(e.message);
        }
      }
    });
  }

  private updateRefrigeratorSalePoint() {
    const confirm = this.matDialog.open(SimpleConfirmActionDialogComponent, {
      data: {
        title: 'Ενημέρωση Σημείου Πώλησης',
        message: `Είστε σίγουροι ότι θέλετε να αφαιρέσετε το Σημείο Πώλησης από το ψυγείο;`
      }
    });

    confirm.afterClosed().subscribe(async (result) => {
      if (result) {
        try {
          await this.commonService.updateObject(`refrigerator/remove_sp`,
            {id : this.refrigerator.id});
          this.toastMessagesService.toastMessages(`Η ενημέρωση του ψυγείου πραγματοποιήθηκε με επιτυχία`);
          location.reload();
        } catch (e) {
          this.toastMessagesService.toastErrorMessage(e.message);
        }
      }
    });
  }

  private reEvaluateRefrigerator() {
    const confirm = this.matDialog.open(SimpleConfirmActionDialogComponent, {
      data: {
        title: 'Επαναξιολόγηση Ψυγείου',
        message: `Είστε σίγουροι ότι θέλετε να θέσετε το ψυγείο με σειριακό ${this.refrigerator.serial_number} για επαναξιολόγηση;`
      }
    });

    confirm.afterClosed().subscribe(async (result) => {
      if (result) {
        try {
          const data = await this.commonService.updateObject(`refrigerator/re_evaluate`,
            {serial_number : this.refrigerator.serial_number});

          if (data && data.id) {
            this.matDialog.open(ActionCompletionDialogComponent, {
              data: {
                buttonText: 'Πλοήγηση στην εντολή συντήρησης',
                redirectURL: `repair_details/${data.id}`
              }
            });
          } else {
            this.matDialog.open(ActionCompletionDialogComponent, {
              data: {
                buttonText: 'Πλοήγηση στα ψυγεία',
                redirectURL: `refrigerators`
              }
            });
          }
        } catch (e) {
          this.toastMessagesService.toastErrorMessage(e.message);
        }
      }
    });
  }

  private recycleRefrigerator() {
    const confirm = this.matDialog.open(SimpleConfirmActionDialogComponent, {
      data: {
        title: 'Δημιουργία Εντολής Φόρτωσης Ανακύκλωσης Ψυγείου',
        message: `Είστε σίγουροι ότι θέλετε να θέσετε το ψυγείο με σειριακό ${this.refrigerator.serial_number} προς Ανακύκλωση;`
      }
    });

    confirm.afterClosed().subscribe(async (result) => {
      if (result) {
        try {
          const data = await this.recycleCommandsService.insertRecycleCommand({serial_number : this.refrigerator.serial_number});
          if (data) {
            this.matDialog.open(ActionCompletionDialogComponent, {
              data: {
                buttonText: 'Πλοήγηση στην εντολή ανακύκλωσης',
                redirectURL: `recycle_details/${data.id}`
              }
            });
          }
        } catch (e) {
          this.toastMessagesService.toastErrorMessage(e.message);
        }
      }
    });
  }

  private saleRefrigerator() {
    const confirm = this.matDialog.open(SimpleConfirmActionDialogComponent, {
      data: {
        title: 'Δημιουργία Εντολής Φόρτωσης Πώλησης Ψυγείου',
        message: `Είστε σίγουροι ότι θέλετε να θέσετε το ψυγείο με σειριακό ${this.refrigerator.serial_number} προς Πώληση;`
      }
    });

    confirm.afterClosed().subscribe(async (result) => {
      if (result) {
        try {
          const data = await this.saleCommandsService.insertSaleCommand({serial_number : this.refrigerator.serial_number});
          if (data) {
            this.matDialog.open(ActionCompletionDialogComponent, {
              data: {
                buttonText: 'Πλοήγηση στην εντολή πώλησης',
                redirectURL: `sale_details/${data.id}`
              }
            });
          }
        } catch (e) {
          this.toastMessagesService.toastErrorMessage(e.message);
        }
      }
    });
  }

  setDataSourceAttributes() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  public setTableHeight(): number {
    return window.innerHeight - 403;
  }

  protected showActions(): boolean {
    return true;
  }
}
